var _style, _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle2, _polygon, _path23, _polygon2, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850 718.4",
    style: {
      enableBackground: "new 0 0 850 718.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#3F3D56;}\n\t.st2{fill:#E6E6E6;}\n\t.st3{fill:#F2F2F2;}\n\t.st4{fill:#424242;}\n\t.st5{opacity:0.2;enable-background:new    ;}\n\t.st6{fill:#FFB8B8;}\n\t.st7{fill:#2F2E41;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M652.7,666.4H267.8c-5,0-9-4-9-9V394.6c0-5,4-9,9-9h384.9c5,0,9,4,9,9v262.8 C661.7,662.4,657.7,666.4,652.7,666.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M652.7,666.4H267.8c-5,0-9-4-9-9V394.6c0-5,4-9,9-9h384.9c5,0,9,4,9,9v262.8 C661.7,662.4,657.7,666.4,652.7,666.4z M267.8,387.6c-3.9,0-7,3.1-7,7v262.8c0,3.9,3.1,7,7,7h384.9c3.9,0,7-3.1,7-7V394.6 c0-3.9-3.1-7-7-7H267.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M504.8,664.8h-89.1V517.3c0-7.3,5.9-13.2,13.2-13.2h62.7c7.3,0,13.2,5.9,13.2,13.2V664.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M631.7,329.6h-50.9v-85c0-5,4-9,9-9h32.9c5,0,9,4,9,9V329.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M631.7,329.6h-50.9v-85c0-5,4-9,9-9h32.9c5,0,9,4,9,9V329.6z M582.8,327.6h46.9v-83c0-3.9-3.1-7-7-7h-32.9 c-3.9,0-7,3.1-7,7V327.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 344.8,
    cy: 267.4,
    r: 98
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M607.8,220.6c-8.8-0.3-16.7-8.3-16.7-17.2s7.7-17,16.5-17.4c19.6-0.9,35.7-22,31.4-41.2 c-4.3-19.2-27.9-31.3-46-23.7C579,127,565,108.6,568.5,94s16.9-24.5,29.2-33.2s25.5-18.9,28.5-33.6S614-5.3,600.5,1.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M378.1,547h-75.3c-6.3,0-11.3-5.1-11.3-11.3v-62.1c0-6.3,5.1-11.3,11.3-11.3h75.3c6.3,0,11.3,5.1,11.3,11.3 v62.1C389.4,541.9,384.3,547,378.1,547z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M619.5,547h-75.3c-6.3,0-11.3-5.1-11.3-11.3v-62.1c0-6.3,5.1-11.3,11.3-11.3h75.3c6.3,0,11.3,5.1,11.3,11.3 v62.1C630.8,541.9,625.7,547,619.5,547z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M230.1,391v-40.4c0-6.3,3.4-12.2,8.9-15.3l224.7-128.4c5.7-3.2,12.7-3.1,18.2,0.4l200.4,127.8 c5.1,3.2,8.1,8.8,8.1,14.9v41c0,9.7-7.9,17.6-17.6,17.6l0,0H247.7C238,408.6,230.1,400.7,230.1,391z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M672.8,390.6H247.7c-9.7,0-17.6-7.9-17.6-17.6v16c0,9.7,7.9,17.6,17.6,17.6h425.1c9.7,0,17.6-7.9,17.6-17.6v-16 C690.5,382.7,682.6,390.6,672.8,390.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M707.4,529c0-31,25.1-104.6,56.1-104.6S819.6,498,819.6,529s-25.1,56.1-56.1,56.1S707.4,560,707.4,529z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M763.5,665.2c-0.6,0-1-0.4-1-1V462.6c0-0.6,0.4-1,1-1s1,0.4,1,1v201.6C764.5,664.8,764,665.2,763.5,665.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M763.5,552c-0.6,0-1-0.4-1-1c0-0.3,0.1-0.5,0.3-0.7l28.5-30c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-28.5,30 C764,551.9,763.8,552,763.5,552z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M763.5,501.5c-0.2,0-0.5-0.1-0.7-0.3l-24.7-22.6c-0.4-0.4-0.4-1-0.1-1.4c0.4-0.4,1-0.4,1.4-0.1l0,0l24.7,22.6 c0.4,0.4,0.4,1,0.1,1.4C764,501.4,763.8,501.5,763.5,501.5L763.5,501.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22,467.3c0-45.6,37-153.9,82.6-153.9s82.6,108.2,82.6,153.9s-37,82.6-82.6,82.6S22,512.9,22,467.3L22,467.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.6,667.2c-0.6,0-1-0.4-1-1V369.6c0-0.6,0.4-1,1-1s1,0.4,1,1v296.6C105.6,666.8,105.2,667.2,104.6,667.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.6,500.7c-0.6,0-1-0.4-1-1c0-0.3,0.1-0.5,0.3-0.7l42-44.1c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4 c0,0,0,0,0,0l-42,44.1C105.2,500.6,104.9,500.7,104.6,500.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.6,426.4c-0.2,0-0.5-0.1-0.7-0.3L67.7,393c-0.4-0.4-0.4-1-0.1-1.4s1-0.4,1.4-0.1l36.3,33.2 c0.4,0.4,0.4,1,0.1,1.4C105.2,426.3,104.9,426.4,104.6,426.4L104.6,426.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M724.3,665.1c0.1,0.1,0.2,0.1,0.3,0.2h81.3c1.6-6.5,2.2-12.9-0.2-18.5c-3.4-8-13.4-13-21.4-9.6 c-1.9,0.8-3.5,2.1-4.8,3.8c-3.1-5.6-8.7-9.8-15.2-9.8c-8.1,0-14.8,6.6-17,14.3c-3.5-6-10.5-10.1-17.3-8.3 C718.5,640.2,714.9,657.9,724.3,665.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.7,666.9c0.2,0.1,0.4,0.3,0.6,0.4h164.1c3.2-13,4.4-26.1-0.5-37.4c-6.8-16.1-27.1-26.2-43.2-19.3 c-3.8,1.7-7.1,4.3-9.7,7.6c-6.3-11.3-17.6-19.8-30.6-19.8c-16.3,0-29.9,13.4-34.3,28.8c-7.1-12-21.2-20.5-35-16.8 C14.2,616.5,6.9,652.3,25.7,666.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M286.8,623.7c0.8-3-1-6-4-6.8c-0.3-0.1-0.6-0.1-1-0.2l-31.8-39.7l-7.9,7.3l33.5,37.9c0,3.1,2.5,5.6,5.6,5.7 C283.9,628,286.2,626.2,286.8,623.7L286.8,623.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.2,583.4l-10,7.7c-1.1,0.8-2.7,0.6-3.5-0.5c-0.1-0.1-0.1-0.2-0.2-0.3l-6.1-11c-2.3-3.1-1.7-7.4,1.4-9.7 c3-2.3,7.4-1.7,9.7,1.3l9,8.7c1,1,1,2.5,0.1,3.5C256.3,583.2,256.3,583.3,256.2,583.4L256.2,583.4z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 239.3,
    cy: 546.6,
    r: 12.8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "266.5,712.2 272.9,712.2 272.3,700.3 262.9,700.3 "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M264.9,710.1l12.5,0h0c4.4,0,8,3.6,8,8c0,0,0,0,0,0v0.3l-20.5,0L264.9,710.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "198.6,703.2 204,706.5 209.8,696 203.2,691.9 "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M198.3,700.5l10.7,6.6l0,0c3.8,2.3,4.9,7.2,2.6,11c0,0,0,0,0,0l-0.1,0.2L194,707.6L198.3,700.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M266.1,708.7c-1,0-1.8-0.6-2.2-1.5l-23-55.1c-0.1-0.4-0.6-0.6-1-0.5c-0.2,0.1-0.3,0.2-0.4,0.3l-31.7,49.9 c-0.6,1-1.9,1.3-2.9,0.8l-4.3-2c-1.2-0.5-1.7-1.9-1.1-3.1l25.9-57.8c-0.6-1.4-6.1-15.5,2.4-22.5l0.1,0l23-10.3l0.6,17.7l22.9,79.6 c0.4,1.2-0.4,2.5-1.6,2.9c0,0,0,0-0.1,0l-6,1.6C266.5,708.7,266.3,708.7,266.1,708.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.2,581.1c-0.9-3.5-2.1-7.1-3.8-8.7c-0.6-0.6-1.2-1.2-1.7-1.9c-1.1-1.4-2.5-2.6-4.1-3.4 c0.6-0.3,0.9-0.7,0.9-1.1c0-1.1-2.6-2.1-5.7-2.1s-5.7,0.9-5.7,2.1c0,0.3,0.1,0.5,0.3,0.7c-4.2,1.7-7.1,5.6-7.5,10.1 c-0.7,7.9-1,18,1.6,24.4c2.2,5.3,2.3,11.2,0.5,16.6c-0.4,1.1,0.2,2.3,1.3,2.6c0.5,0.2,1,0.1,1.4,0l22.8-9.2c0.8-0.3,1.3-1.1,1.3-1.9 v-14C252.9,590.5,252.3,585.7,251.2,581.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.5,638.6c3-0.7,4.9-3.7,4.2-6.7c-0.1-0.3-0.2-0.6-0.3-0.9l17.9-47.1l-9.1-2.3l-16.5,46.6 c-2.8,1.4-3.9,4.8-2.5,7.5C202.4,638,205,639.2,207.5,638.6L207.5,638.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.1,592.8l-11.4-5.4c-1.3-0.6-1.8-2.1-1.2-3.3c0.1-0.1,0.1-0.2,0.2-0.3l7-10.5c1.7-3.5,5.8-4.9,9.3-3.3 c3.4,1.6,4.9,5.8,3.3,9.2l-3.6,12c-0.4,1.3-1.8,2.1-3.1,1.7C229.4,592.9,229.3,592.9,229.1,592.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M251,543.5c0.6,0.1,1.2,0,1.7-0.3c0.9-0.6,0.8-2,0.5-3.1c-1.6-5.3-5.8-9.3-11.1-10.8c-1.8-0.5-4.1-0.5-5.2,1.1 c-5.4-3.6-12.6-2.7-17,2.1c-2.1,2.4-3.4,5.4-4,8.5c-1.1,5.3-5.8,16.4-3.2,21.2c1.7,3.2,9.6,0.7,13,2.1c3.4,1.5,7.3,1.2,10.4-0.8 c3.1-2.1,4.4-6,3.3-9.6c-0.6-1.3-1.3-2.5-2-3.7c-0.8-1.2-1.1-2.6-0.9-4C237.1,544,247.1,543.4,251,543.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewing);
export default __webpack_public_path__ + "static/media/viewing.c9f11784e82c01597754b1de9ec39919.svg";
export { ForwardRef as ReactComponent };